import { ChevronRight } from 'lucide-react';
import React from 'react';
const ProductLink = ({ name, image, position }) => {
    return (React.createElement("div", { className: "grid grid-cols-[6rem_1fr] gap-1.5 md:gap-3 pb-5 border-b-2 border-b-black md:max-w-[245px] lg:max-w-full text-black w-full" },
        React.createElement("div", { className: "aspect-square size-full relative" }, image && (React.createElement("img", { className: "size-full object-cover rounded-md", src: image, alt: "Product Link" }))),
        React.createElement("div", { className: "flex flex-col justify-between border-r border-right-[#474C50] w-full" },
            position && React.createElement("span", { className: "text-[26px]" }, position),
            React.createElement("div", { className: "flex justify-between items-center" },
                name && React.createElement("span", { className: "font-medium text-lg leading-none" }, name),
                React.createElement(ChevronRight, { size: 40 })))));
};
export { ProductLink };
